import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/TopicExpertService";
const store = {};
const mutations = {

    SET_TEX() { }
};
const state = {
};
const getters = {};
const actions = {
    updateMyTex({ commit }, args) {
        var formData = new FormData();
        var data = JSON.stringify(args);
        formData.append("data", data);

        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_TEX', res.data);
                } else {
                    alert("An error occured while updating your record: " + res.data.errorMessage);
                }
            });
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}